import type { ArenaMapChoice, GameMode } from '@evolution/shared';
import { assertArenaServerCompatibility, ARENA_SERVER_COMPATIBILITY_ERROR } from './server-compatibility';

export const ARENA_MAP_SELECTION_UNAVAILABLE = 'Arena map selection unavailable';

/** Select a proven wire contract, never infer features from the installed AAB.
 * The 1.1.20 public server implements map protocol 1 but does not advertise it.
 * Explicit map selection requires protocol 2; silently changing teams to FFA
 * or retrying an arbitrary rejected ticket would violate the player's choice. */
export function selectArenaEntryCapabilities(meta: unknown, mode: GameMode, choice?: ArenaMapChoice): { mapProtocol?: 1 | 2; mapChoice?: ArenaMapChoice } {
  assertArenaServerCompatibility(meta);
  const value = meta as { clientVersion: string; maintenance?: unknown; arenaMaps?: unknown };
  if (value.maintenance !== false) throw Error('Maintenance mode');
  if (value.arenaMaps !== undefined) {
    const maps = value.arenaMaps as { protocol?: unknown; enabled?: unknown } | null;
    if (!maps || maps.protocol !== 2 || !Array.isArray(maps.enabled)) throw Error(ARENA_SERVER_COMPATIBILITY_ERROR);
    if (mode === 'practice') return {};
    if (choice && choice !== 'random' && !maps.enabled.some(map => map && typeof map === 'object' && map.id === choice)) throw Error(ARENA_MAP_SELECTION_UNAVAILABLE);
    return { mapProtocol: 2, ...(choice ? { mapChoice: choice } : {}) };
  }
  const patch = Number(value.clientVersion.split(/[.+]/)[2]);
  if (patch > 20) throw Error(ARENA_SERVER_COMPATIBILITY_ERROR);
  if (mode === 'practice') return {};
  if (choice && choice !== 'random') throw Error(ARENA_MAP_SELECTION_UNAVAILABLE);
  return patch === 20 ? { mapProtocol: 1 } : {};
}
